/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

/*COMPONENT*/
import UploadPhotoProfile from "../../Components/user/UploadPhotoProfile";
import LICENSE_DETAIL from "../../Components/user/LICENSE_DETAIL";
import HISTORY_PAYMENT from "../../Components/user/HISTORY_PAYMENT";
import API_KEY_TOKEN from "./API_KEY_TOKEN";

/*REDUX*/
import {
  logoutUser,
  getMapAccess,
  initApi,
  set_modal_quota_access,
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
} from "../../App/actions/authActions";
import { clearProjectList } from "../../App/actions/projectActions";
import { clearFormList } from "../../App/actions/layerNewActions";
import { getUserPaymentList } from "../../App/actions/paymentActions";
import { getGroups } from "../../App/actions/groupActions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import pic_static from "../../Assets/svg/profile_pic_comment.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";

/*CONST*/
const Paragrah = ({ title, value }) => {
  return (
    <div className="detail_profile_paragraf">
      <p>{title}</p>
      {value ? (
        <span
          style={{
            maxWidth: 200,
            wordBreak: "break-word",
          }}
        >
          {value}
        </span>
      ) : (
        <span>-</span>
      )}
    </div>
  );
};

const UserDashboard = ({
  auth,
  license_reducer,
  logoutUser,
  getUserPaymentList,
  getGroups,
  getMapAccess,
  clearProjectList,
  initApi,
  clearFormList,
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
}) => {
  const params = useParams();

  const [menu_active, setMenuActive] = useState("license");
  //license || list_payment || api_key

  useEffect(() => {
    const tab_list = ["license", "list_payment", "api_key"]
    const params = new URLSearchParams(window.location.search)
    const tab_value = params.get("tab")
    if (tab_list.includes(tab_value)) {
      setMenuActive(tab_value)
    }
  }, [window.location.search])


  useEffect(() => {
    get_quota_access();
    get_quota_access_sini_ai();
    get_quota_ai_chat();
    getUserPaymentList();
    getGroups();
    getMapAccess();
  }, [
    get_quota_access,
    get_quota_access_sini_ai,
    get_quota_ai_chat,
    getUserPaymentList,
    getGroups,
    getMapAccess,
    params?.status,
  ]);

  const on_set_menu = (menu_active) => {
    setMenuActive(menu_active);
  };

  const handleInitApi = () => {
    const body = {};
    initApi(body);
  };

  const onLogoutClick = () => {
    const payment = localStorage.getItem("payment");
    if (payment) {
      localStorage.removeItem("payment");
    }
    logoutUser();
    clearProjectList();
    clearFormList();
  };

  //local storage
  const language = localStorage?.language || "ina";

  //local state

  //global props
  const { map_access, max_quota, domain, user } = auth;

  //content
  const status_domain = domain_list?.[domain]?.status;
  let delta_access = max_quota - map_access;
  if (delta_access < 0) {
    delta_access = 0;
  }

  const url_pic =
    user && user.profile_picture && user.profile_picture.url
      ? user.profile_picture.url
      : pic_static;

  return (
    <div className="main_container" style={{ minHeight: "90vh" }}>
      <main>
        <section>
          <div className="detail_profile_wrapper">
            <div
              style={{
                marginRight: "2rem",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  height: "77px",
                  width: "77px",
                  display: "block",
                  border: "5px solid #dedede",
                  borderRadius: "13px",
                  backgroundImage: `url(${url_pic})`,
                  backgroundSize: "cover",
                }}
              />
              <UploadPhotoProfile />
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <h1
                  style={{
                    fontSize: "23px",
                    fontWeight: "470",
                    lineHeight: "110%",
                    marginRight: "1rem",
                  }}
                >
                  {user.full_name ? user.full_name : user.name}
                </h1>
                <Link
                  to={`/editprofile`}
                  className="button background_black margin_right"
                  data-mapid="clickEdit"
                >
                  {dict["Edit profile"][language]}
                </Link>
                <div onClick={onLogoutClick} className="button background_red">
                  {dict["Sign out"][language]}
                </div>
              </div>
              <p style={{ textAlign: "justify", padding: "0 0.5rem" }}>
                {user.bio}
              </p>
              <div className="detail_profil_value">
                <Paragrah
                  title={dict["Username"][language]}
                  value={user.name}
                />
                <Paragrah title="E-mail" value={user.email} />
                <Paragrah
                  title={dict["phone number"][language]}
                  value={user.phone_number}
                />
                <Paragrah
                  title={dict["Birthday"][language]}
                  value={user.birthday}
                />
                <Paragrah
                  title={dict["industry"][language]}
                  value={user.industry}
                />
              </div>
            </div>
          </div>
        </section>
        <br />
        {status_domain !== "premium" && (
          <section>
            <div className="detail_profile_wrapper">
              <main>
                <br />
                <button
                  className={`text_medium margin_right margin_bottom ${menu_active === "license" ? "underline_active" : "sub_color"
                    }`}
                  style={{ marginRight: "33px" }}
                  onClick={() => on_set_menu("license")}
                >
                  Lisensi
                </button>
                <button
                  className={`text_medium margin_right margin_bottom ${menu_active === "list_payment"
                    ? "underline_active"
                    : "sub_color"
                    }`}
                  style={{ marginRight: "33px" }}
                  onClick={() => on_set_menu("list_payment")}
                >
                  History Payment
                </button>
                <button
                  className={`text_medium margin_right margin_bottom ${menu_active === "api_key" ? "underline_active" : "sub_color"
                    }`}
                  style={{ marginRight: "33px" }}
                  onClick={() => on_set_menu("api_key")}
                >
                  API Key
                </button>
                <br />
                <br />

                {menu_active === "license" ? <LICENSE_DETAIL /> : null}
                {menu_active === "list_payment" ? <HISTORY_PAYMENT /> : null}
                {menu_active === "api_key" ? (
                  <API_KEY_TOKEN auth={auth} handleInitApi={handleInitApi} />
                ) : null}
              </main>
            </div>
          </section>
        )}
      </main>
      {/* {modal_token_content} */}
      <Helmet>
        <title>{dict["Profile"][language]}</title>
        <meta name="description" content={dict["Profile"][language]} />
      </Helmet>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  properties: state.properties,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  logoutUser,
  getUserPaymentList,
  getGroups,
  getMapAccess,
  clearProjectList,
  initApi,
  clearFormList,
  set_modal_quota_access,
  set_value_properties,
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
})(UserDashboard);
